import Icon from '../components/Icon.vue'

Icon.register({"backward":{"width":1664,"height":1792,"paths":[{"d":"M1619 141q19-19 32-13t13 32v1472q0 26-13 32t-32-13l-710-710q-9-9-13-19v710q0 26-13 32t-32-13l-710-710q-19-19-19-45t19-45l710-710q19-19 32-13t13 32v710q4-10 13-19z"}]}})



// WEBPACK FOOTER //
// ./~/vue-awesome/icons/backward.js